<template>
  <div>
    <progress-bar class="c-progress-header" :value="2" :max="6" label="stappen">Progress</progress-bar>
    <h1 class="c-heading-1">Welke trends geven jouw toekomst vorm?</h1>
    <p>De FutureForward-scan schotelt jou bepaalde trends voor die belangrijk kunnen zijn voor jou, je bedrijf of je sector. Aangezien het trends zijn, zullen die niet zomaar veranderen of verdwijnen. Deze trends zijn trouwens niet enkel in Vlaanderen, Brussel of België te herkennen, zij zijn eerder wereldwijd. Daarom zijn de eerste 2 vragen per trend ook telkens eerder lange termijn-vragen.</p>
    <p>De trends worden jou voorgesteld op basis van je activiteit en zijn dus verschillend naargelang je sector.</p>
    <div class="css-input-group-container">
    <input-group
      label="Maak een keuze uit onderstaande sectoren voor op maat gekozen trends. Kan je (nog) niet kiezen voor jouw sector? Kies dan 'Andere' en typ je sector in, wij proberen een aangepaste scan te ontwikkelen. Voorlopig krijg jij nu een algemene scan."
    >
      <div class="c-organization-row" slot-scope="{ uniqueId }">
        <OrganizationSelector v-model="organizations"/>
      </div>
    </input-group>

    <input-group>
    <div class="c-organization-row__optional" v-if="hasOrganization('other')" >
      <input
        type="text"
        class="c-input"
        placeholder="Typ hier uw sector..."
        v-model="organizationInput"
      >
    </div>
    </input-group>
    </div>
    <div class="c-toolbar">
      <navigation-button to="infocircles" @click="submitOrganization">Ga verder</navigation-button>
    </div>
  </div>
</template>

<script>
import InputGroup from "../components/InputGroup";
import NavigationButton from "../components/NavigationButton";
import ProgressBar from "../components/ProgressBar";
import OrganizationSelector from "../components/OrganizationSelector";
export default {
  components: {
    InputGroup,
    NavigationButton,
    ProgressBar,
    OrganizationSelector
  },
  data() {
    return {
      organizations: ["algemeen"],
      organizationInput: ""
    };
  },
  computed: {
    hasOrganization() {
      return org => this.organizations.includes(org);
    }
  },
  methods: {
    checkOrganizations() {
      if (!this.organizations.includes("algemeen")) {
        this.organizations.unshift("algemeen");
      }
    },
    submitOrganization() {
      this.checkOrganizations();
      this.$store.commit("updateCompanyTypes", {
        organizations: this.organizations,
        organizationInput: this.hasOrganization("other")
          ? this.organizationInput
          : ""
      });
      this.$store.commit("updateProgress", "ORGANIZATION_COMPLETED");
      this.$store.dispatch("updateDatabaseRecord");
    }
  },
  mounted() {
    let companyTypes = this.$store.state.companyTypes;
    if (!companyTypes || !companyTypes.length) {
      companyTypes = [this.$store.state.companyType];
    }
    this.organizations = companyTypes;
    this.organizationInput = this.$store.state.companyTypeInput;
    this.checkOrganizations();
  }
};
</script>

<style lang="scss">
.c-organization-row {
  display: flex;
  justify-content: space-between;

  & > * {
    flex: 1 1 auto;
  }
}

.c-organization-row__optional {
  margin-left: 2rem;
}
.c-input:nth-of-type(1) {
  margin-bottom: 0;
}

</style>
